import styled from "styled-components";

export default styled.div`
  &.factors-appear {
    opacity: 0;
  }

  &.factors-appear-active {
    opacity: 1;
    transition: opacity 500ms;
  }
`;
